import React, { useState, useEffect } from 'react';
import api from '../services/api';

function CheckoutForm() {
  const [books, setBooks] = useState([]);
  const [users, setUsers] = useState([]);
  const [checkouts, setCheckouts] = useState([]);
  const [selectedBook, setSelectedBook] = useState('');
  const [selectedUser, setSelectedUser] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [booksRes, usersRes, checkoutsRes] = await Promise.all([
        api.get('/books'),
        api.get('/users'),
        api.get('/checkouts')
      ]);
      setBooks(booksRes.data);
      setUsers(usersRes.data);
      setCheckouts(checkoutsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const checkoutBook = async (e) => {
    e.preventDefault();
    try {
      await api.post('/checkouts', {
        bookId: selectedBook,
        userId: selectedUser
      });
      setSelectedBook('');
      setSelectedUser('');
      fetchData();
    } catch (error) {
      console.error('Error checking out book:', error);
      alert('Error checking out book');
    }
  };

  const checkinBook = async (checkoutId) => {
    try {
      await api.put(`/checkouts/${checkoutId}/checkin`);
      fetchData();
    } catch (error) {
      console.error('Error checking in book:', error);
    }
  };

  if (loading) return <div>Loading...</div>;

  const availableBooks = books.filter(book => !book.is_checked_out);

  return (
    <div>
      <h2>Check Out/In Books</h2>
      
      <form onSubmit={checkoutBook} style={{marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '4px'}}>
        <h3>Check Out Book</h3>
        <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
          <select
            value={selectedBook}
            onChange={(e) => setSelectedBook(e.target.value)}
            style={{flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            required
          >
            <option value="">Select a book...</option>
            {availableBooks.map((book) => (
              <option key={book.id} value={book.id}>
                {book.title} by {book.author}
              </option>
            ))}
          </select>
          <select
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            style={{flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            required
          >
            <option value="">Select a user...</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.first_name} {user.last_name} ({user.teacher})
              </option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          disabled={!selectedBook || !selectedUser}
          style={{
            padding: '8px 16px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: selectedBook && selectedUser ? 'pointer' : 'not-allowed'
          }}
        >
          Check Out Book
        </button>
      </form>

      <div>
        <h3>Currently Checked Out Books ({checkouts.filter(c => !c.checked_in_at).length})</h3>
        {checkouts.filter(c => !c.checked_in_at).length === 0 ? (
          <p>No books currently checked out.</p>
        ) : (
          <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
              <tr style={{backgroundColor: '#f8f9fa'}}>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Book</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>User</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Checked Out</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {checkouts.filter(c => !c.checked_in_at).map((checkout) => (
                <tr key={checkout.id}>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    {checkout.book_title} by {checkout.book_author}
                  </td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    {checkout.user_first_name} {checkout.user_last_name}
                  </td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    {new Date(checkout.checked_out_at).toLocaleDateString()}
                  </td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    <button
                      onClick={() => checkinBook(checkout.id)}
                      style={{
                        padding: '4px 8px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Check In
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div style={{marginTop: '30px'}}>
        <h3>Checkout History</h3>
        {checkouts.filter(c => c.checked_in_at).length === 0 ? (
          <p>No checkout history.</p>
        ) : (
          <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
              <tr style={{backgroundColor: '#f8f9fa'}}>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Book</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>User</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Checked Out</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Checked In</th>
              </tr>
            </thead>
            <tbody>
              {checkouts.filter(c => c.checked_in_at).slice(0, 10).map((checkout) => (
                <tr key={checkout.id}>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    {checkout.book_title} by {checkout.book_author}
                  </td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    {checkout.user_first_name} {checkout.user_last_name}
                  </td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    {new Date(checkout.checked_out_at).toLocaleDateString()}
                  </td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    {new Date(checkout.checked_in_at).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default CheckoutForm;
